import type { Permissions } from '@models';
import type { RouteMetadata } from '@routes/types';

export interface CheckRoutePermissionParams {
  /**
   * The permissions list object associated with the user
   */
  permissions: Permissions | null;
  /**
   * The route metadata object for the path
   */
  route: RouteMetadata;
}

/**
 * This utility function inspects the current metadata for a path and determines
 * whether the user has the requisite permissions to view it.
 */
export const checkRoutePermission = ({
  permissions,
  route,
}: CheckRoutePermissionParams): boolean => {
  // If the route has no required permissions, return true
  if (
    !Array.isArray(route?.navbar?.permissions) ||
    !route.navbar.permissions.length
  ) {
    return true;
  }

  return route.navbar.permissions.reduce<boolean>(
    (hasPermission, { action }, currentIndex) => {
      // If the first required permission has been checked and is false, skip
      // any remaining checks
      if (currentIndex > 0 && !hasPermission) return hasPermission;

      return !!permissions?.[action];
    },
    false,
  );
};

export default checkRoutePermission;
